// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { tableCounterStyles } from "@steiner/App/Components/Common/TableCounter";
import tableWidgetsSharedStyles from "@steiner/App/SharedStyles/TableWidgetsStyles";
import { color, styledScrollbar } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

tableCounterStyles.headingContainer = {
    ...tableWidgetsSharedStyles.headingContainer,
};

tableCounterStyles.heading = {
    ...tableWidgetsSharedStyles.heading,
};

tableCounterStyles.rangeAndNavigationContainer = {
    ...tableWidgetsSharedStyles.rangeAndNavigationContainer,
};

tableCounterStyles.viewAllLink = {
    ...tableWidgetsSharedStyles.viewAllLink,
};

tableCounterStyles.tableAccordionSectionProps = {
    ...tableWidgetsSharedStyles.accordionSectionProps,
};

tableCounterStyles.cartLinesHeaderContainer = {
    css: css`
        max-height: 750px;
        ${styledScrollbar()}

        @media print {
            display: block;
            max-height: 100%;
        }
    `,
};

tableCounterStyles.displayRange = {
    color: "common.white",
    lineHeight: "19px",
    css: css`
        background: ${color("primary")};
        text-align: right;
        display: block;
    `,
};
